import { api } from "./axios-instance";
import { NAVIGATION_LOGS } from "./constants";

const SESSION_KEY = 'session_id';

const getSessionId = () => {
  let session = sessionStorage.getItem(SESSION_KEY);

  if (!session) {
    session = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, session);
  }

  return session;
};

export const trackPageView = async (page: string, duration?: number) => {
  try {
    await api.post(NAVIGATION_LOGS, {
      type: 'NAVIGATION',
      action: 'PAGE_VIEW',
      page,
      duration,
      sessionId: getSessionId(),
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });
  } catch (e) {
    console.warn('tracking failed');
  }
};